import React from 'react';
import styled from 'styled-components';
import CircularProgress from '@mui/material/CircularProgress';

/**
 * LoadingSpinner 컴포넌트 Props
 * @typedef {Object} LoadingSpinnerProps
 * @property {number} [size=40] - 스피너 크기
 * @property {string} [height='auto'] - 컨테이너 높이
 * @property {string} [color='#1976d2'] - 스피너 색상
 * @property {string} [p='0'] - 패딩
 */

const LoadingSpinner = ({ size = 40, height = 'auto', color = '#1976d2', p = '0' }) => {
  return (
    <Wrapper $height={height} $p={p} $color={color}>
      <CircularProgress size={size} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${(p) => p.$height};
  padding: ${(p) => p.$p};

  .MuiCircularProgress-root {
    color: ${(p) => p.$color};
  }
`;

export default LoadingSpinner;
